(function() {
  var Hammer, touch;

  Hammer = require('public/bower_components/hammerjs/hammer');

  touch = exports;

  touch.draggableSel = '.ui-draggable, .ui-resizable-handle';

  touch.textboxSel = 'input[type="text"], [contenteditable]';

  touch.initialize = function() {
    var h, self;
    self = touch;
    h = Hammer(document);
    h.on('dragstart', function(event) {
      var ref;
      if (!event.gesture || event.gesture.pointerType === 'mouse') {
        return;
      }
      if (((ref = event.gesture.srcEvent.changedTouches) != null ? ref[0] : void 0) != null) {
        self._fireEvent(event.target, 'mousedown', event.gesture.srcEvent.changedTouches[0]);
        return self._fireEvent(event.target, 'mousemove', event.gesture.srcEvent.changedTouches[0]);
      }
    });
    h.on('drag', function(event) {
      var ref;
      if (!event.gesture || event.gesture.pointerType === 'mouse') {
        return;
      }
      if (((ref = event.gesture.srcEvent.changedTouches) != null ? ref[0] : void 0) != null) {
        return self._fireEvent(event.target, 'mousemove', event.gesture.srcEvent.changedTouches[0]);
      }
    });
    return h.on('dragend', function(event) {
      var ref;
      if (!event.gesture || event.gesture.pointerType === 'mouse') {
        return;
      }
      if (((ref = event.gesture.srcEvent.changedTouches) != null ? ref[0] : void 0) != null) {
        return self._fireEvent(event.target, 'mouseup', event.gesture.srcEvent.changedTouches[0]);
      }
    });
  };

  touch._fireEvent = function(object, evt, touch) {
    var simulatedEvent;
    simulatedEvent = document.createEvent('MouseEvent');
    simulatedEvent.initMouseEvent(evt, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
    return object.dispatchEvent(simulatedEvent);
  };

}).call(this);
